import IMAGES from "@/public/assets/img";
import Image from "next/image";

const ExporterChallenge = ({ challenge }) => {
  return (
    <section className="sm:py-20 py-[100px] relative">
      <div className="container px-3 lg:px-3 xm:px-2">
        <h2 className="text-textxl font-medium text-center">
          {challenge.sectionTitle}
        </h2>

        <h3 className="text-3xl font-medium baseBlack mt-1 text-center sm:text-2xl">
          {challenge.mainHeading}
        </h3>

        <p className="text-lg mt-4 text-baseBlack text-center"  dangerouslySetInnerHTML={{ __html:  challenge.description }} />
        <div className="flex justify-between gap-6 mt-16 sm:flex-col">
          <div className="w-[45%] sm:w-full h-full">
            <h3 className="text-textxl font-semibold text-baseBlack">
              {challenge.subSectionTitle}
            </h3>
            <p className="text-baseBlack text-lg font-normal mt-2">
              {challenge.subSectionDescription}
            </p>
            <p className="text-baseBlack text-lg font-normal">
              {challenge.include}
            </p>
            <ul className="mt-4 space-y-4">
              {challenge.benefits.map((item, index) => (
                <li key={index} className="flex items-start gap-3">
                  <Image
                    src={item.icon}
                    alt="Benefit icon"
                    width={24}
                    height={24}
                    className="mt-1"
                    priority={true}
                  />
                  <span className="text-baseBlack text-lg sm:text-base font-medium">
                    {item.text}
                  </span>
                </li>
              ))}
            </ul>
          </div>
          {/* Right Side Image */}
          <div className="w-1/2 sm:w-full h-full">
            <Image
              src={IMAGES?.MachineryLoan?.industrialPlant}
              alt="Industrial plant"
              width={600}
              height={400}
              className="rounded-lg object-cover"
              priority={true}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExporterChallenge;
